import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { DateService, DateUnit } from "@app/services/date.service";
import { VorRecordStatus } from "@components/resourceManagement/vor/vor.interfaces";
import { IVehicle } from "@interfaces/IVehicle";
import { ReasonCodeService } from "@services/reasonCode.service";
import "./vehicle-status.component.scss";
import { VehicleStatusService } from "./vehicle-status.service";

@Component({
    selector: "vehicle-status",
    template: require("./vehicle-status.component.html")
})
export class VehicleStatusComponent implements OnInit, OnChanges {

    @Input() vehicle: IVehicle;
    @Input() hideIndicator: boolean;
    @Input() hideReg: boolean;

    // ---

    text: string;
    color: string;
    tooltipText: string;

    constructor(
        private readonly dateService: DateService,
        private readonly reasonCodeService: ReasonCodeService,
        private readonly vehicleStatusService: VehicleStatusService
    ) {
    }

    ngOnInit() {
        this.update();
    }

    ngOnChanges() {
        this.update();
    }

    // ---

    private update(): void {
        var statusToolTip = this.vehicle?.Plot
            ? this.dateService.formatDate(this.vehicle.Plot.Utc)
            : "No data received";


        this.getVehiclePlot();

        if (!this.vehicle?.Plot) {
            if (!this.vehicle) {
                console.error("No vehicle specified");
            }

            this.setStatus("No data received", "red-color", statusToolTip);
            return;
        }

        if (this.vehicle.vorRecord && this.vehicle.vorRecord.status == VorRecordStatus.Active) {
            this.setStatus(`Vehicle Off Road`, "grey-color", statusToolTip);
            return;
        }

        const isDriving = this.reasonCodeService.isTravelling(this.vehicle.Plot.Reason);
        const ignitionOn = this.reasonCodeService.isIgnitionOn(this.vehicle.Plot.Reason);

        const activityText = isDriving ? "Driving" : "Stationary";
        const lastReported = this.dateService.relativeTime(this.vehicle.Plot.Utc);

        let statusColor = "red-color";
        const sevenDaysAgo = this.dateService.addOrSubtractTime(new Date(), -7, DateUnit.Day);
        const twoDaysAgo = this.dateService.addOrSubtractTime(new Date(), -2, DateUnit.Day);

        if (this.dateService.date1IsAfterDate2(sevenDaysAgo, this.vehicle.Plot.Utc)){
            // stay as red
        }
        else if (this.dateService.date1IsAfterDate2(twoDaysAgo, this.vehicle.Plot.Utc)) {
            statusColor = "orange-color";
        }
        else if (isDriving) {
            statusColor = "green-color";
        }
        else {
            statusColor = ignitionOn ? "green-color" : "grey-color";
        }

        var statusText = activityText;
        if (!isDriving) {
            statusText += (ignitionOn ? " (Ignition On)" : " (Ignition Off)");
        }

        statusText += ` - ${lastReported}`;

        this.setStatus(statusText, statusColor, statusToolTip);
    }

    private setStatus(text: string, color: string = "grey-background", tooltipText: string = "") {
        this.text = text;
        this.color = color;
        this.tooltipText = tooltipText;
    }

    private async getVehiclePlot(): Promise<void> {
        if (this.vehicle.Plot) {
            return;
        }

        const plot = await this.vehicleStatusService.getLatestPlotForVehicle(this.vehicle.Id);

        if (plot) {
            this.vehicle.Plot = plot;
            this.update();
        }

    }
}
